var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifier = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98366 2.86368C6.96188 -0.954562 13.4119 -0.954562 17.3902 2.86368C21.0194 6.34783 21.3375 11.806 18.3457 15.6367L24.5939 21.6342C24.8579 21.8979 25.0037 22.2506 24.9999 22.6164C24.9961 22.9822 24.8431 23.332 24.5736 23.5907C24.3042 23.8494 23.9398 23.9963 23.5588 23.9999C23.1778 24.0036 22.8104 23.8636 22.5357 23.6101L16.2875 17.6126C12.2973 20.4839 6.61288 20.1785 2.98366 16.6943C-0.994554 12.8761 -0.994554 6.68289 2.98366 2.86368ZM5.04187 4.83963C3.67719 6.14976 2.91053 7.92668 2.91053 9.77948C2.91053 11.6323 3.67719 13.4092 5.04187 14.7193C6.40655 16.0295 8.25745 16.7655 10.1874 16.7655C12.1174 16.7655 13.9683 16.0295 15.3329 14.7193C16.6977 13.4091 17.4645 11.632 17.4645 9.77901C17.4645 7.92602 16.6977 6.14893 15.3329 4.83867C13.9681 3.52841 12.117 2.79232 10.1869 2.79232C8.25677 2.79232 6.40569 3.52841 5.04088 4.83867L5.04187 4.83963Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifier);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifier.df9a76c1101b246f0cd569c8f376c083.svg";